import React from "react";
import '../App.css';
import './Obrazovanje.css';
import Header from '../components/Header';
import Footer from '../components/Footer'
import img1 from '../images/modal/111.jpg';
import img2 from '../images/modal/112.jpg';
import img3 from '../images/modal/113.jpg';
import img4 from '../images/modal/114.jpg';
import img5 from '../images/modal/115.jpg';

const Prekvalifikacija = () => {

    return(
        <div>
            <Header />
                <div className="prekvalifikacija">
                    <div>
                        <div className="btt">
                            <h1>Prekvalifikacija</h1>
                            <h4>Polaznik koji je već završio srednju školu odnosno stekao srednju stručnu spremu,<br />
                                a želi se prekvalifikovati za drugu vrstu školske spreme III ili IV stepena,<br />
                                srednjoškolski program upisuje kao program prekvalifikacije za sticanje novog zvanja.<br />
                                <br />
                                Potrebna dokumentacija za upis:<br />
                                - Kopija lične karte <br />
                                - Rodni list <br />
                            - Diplomu o završenoj srednjoj prethodnoj školi <br />
                            - Svjedočanstva o završenim razredima<br /> 
                            - Fotokopiju vozačke dozvole (samo za vozače motornih vozila).</h4>
                        </div>
                        <div className="tabela">
                            <table>
                                 <tr>
                                    <th>Struka</th>
                                    <th>Zanimanje</th>
                                </tr>
                                <tr>
                                    <td>Ekonomija, pravo i trgovina</td>
                                    <td>Ekonomski tehničar <br />
                                    Trgovac <br />
                                    Trgovački tehničar</td>
                                </tr>
                                <tr>
                                    <td>Elektrotehnika</td>
                                    <td>Tehničar elektroenergetike</td>
                                </tr>
                                <tr>
                                    <td>Zdravstvo</td>
                                    <td>Medicinski tehničar</td>
                                </tr>
                                <tr>
                                    <td>Mašinstvo i obrada metala</td>
                                    <td>Automehačinar <br />
                                    Bravar <br />
                                    Varilac <br />
                                    Instalater <br />
                                    Kovač <br />
                                    Limar <br /> 
                                    Metalobrusač <br /> 
                                    Mehaničar <br /> 
                                    Monter <br /> 
                                    Obrađivač metala rezanjem <br /> 
                                    Precizni mehaničar</td>
                                </tr>
                                <tr>
                                    <td>Saobraćaj</td>
                                    <td>Vozač motornih vozila <br />
                                    Tehničar drumskog saobraćaja</td>
                                </tr>
                                <tr>
                                    <td>Ugostiteljstvo i turizam</td>
                                    <td>Konobar <br />
                                    Kuvar <br />
                                    Ugostiteljsko-kulinarski tehničar </td>
                                </tr>
                                <tr>
                                    <td>Ostale djelatnosti</td>
                                    <td>Kozmetički tehničar <br />
                                    Frizer</td>
                                </tr>

                            </table>
                        </div>
                    </div>

                    <div className="nvijesti">
                        <div className="vijestiimg">
                            <img className="vimg" src={img1} alt="vijest1" />
                        </div>

                        <div className="vijestiimg">
                            <img className="vimg" src={img5} alt="vijest4"/>
                        </div>

                        <div className="vijestiimg">
                        <img className="vimg" src={img2} alt="vijest2" />
                        </div>

                        <div className="vijestiimg">
                        <img className="vimg" src={img3} alt="vijest3" />
                        </div>

                        <div className="vijestiimg">
                            <img className="vimg" src={img4} alt="vijest4"/>
                        </div>
                    </div>


                </div>
            <Footer />
        </div>
    );

}

export default Prekvalifikacija;